<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrap">
        <div class="footer__col">
          <h2 class="footer__title">Отдел и продукты</h2>
          <a href="#products-anchor" class="footer__link">Онлайн запись</a>
          <a href="#products-anchor" class="footer__link">Электронный журнал</a>
          <a href="#products-anchor" class="footer__link">SM&Co оповещения/E-mail оповещения</a>
          <a href="#" class="footer__link">Статистика и аналитика</a>
          <a href="#" class="footer__link">Клиентская база</a>
          <a href="#about-anchor" class="footer__link">Нужен ли мне Croinc?</a>
        </div>
        <div class="footer__col">
          <h2 class="footer__title">Цены</h2>
          <!--           <a href="#" class="footer__link">Настроить тариф</a>-->
          <a href="#rates-anchor" class="footer__link">Выбрать тариф</a>
        </div>
        <div class="footer__col">
          <h2 class="footer__title">О компании</h2>
          <a href="#" class="footer__link">Контакты</a>
          <router-link to="/agreement" class="footer__link">
            Пользовательское соглашение
          </router-link>
          <router-link to="/confidential" class="footer__link">
            Политика в отношении обработки персональных данных
          </router-link>
          <router-link to="/banking" class="footer__link">
            Описание процесса оплаты банковской картой
          </router-link>

        </div>
        <div class="footer__col">
          <h2 class="footer__title">Авторизация</h2>
          <a href="/admin2" class="footer__link">Вход</a>
          <router-link to="/register" class="footer__link">
            Регистрация
          </router-link>
        </div>
        <div class="footer__contacts">
          <img :src="`${publicPath}images/logo.svg`" alt="logo" class="footer__logo">
          <form action="https://formspree.io/1blikskrik1@mail.ru"
                method="POST" class="footer__form">
            <h2 class="footer__form-title">Напишите нам</h2>
            <div class="footer__input">
              <input type="email" placeholder="Ваш email">
              <button type="submit" class="footer__btn"></button>
            </div>
          </form>
        </div>
      </div>
      <h3 class="footer__form-title footer__phone-block">
        Позвоните нам
        <a class="phone_number" href="tel:+74996776536"> <i class="material-icons phone-icon">local_phone</i>+7 499 677 65 36</a>
      </h3>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "LandingFooter",
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>

<style scoped>

</style>
